import axios from '@/util/requestUtil'
// const isProd = process.env.NODE_ENV === 'production'
let auth = process.env.NODE_ENV === 'production' ? 'Basic YWNjb3VudF9jZW50ZXI6YTY1ZDAxODQtNzcwMC00OTZhLTk1YTctOTJhMTBkYzA1ZmQw' : 'Basic YWNjb3VudF9jZW50ZXI6YWJjZA=='
class Common {
  // 用户信息、交易帐号信息
  getVCode (params) {
    return axios.get(`${process.env.VUE_APP_AUTH}/v2/sms-code`,
      { params: params, headers: { 'Authorization': auth, 'Content-Type': 'application/x-www-form-urlencoded' } })
  }
  getTokenByCode (params) {
    console.log(process.env.VUE_APP_AUTH, 'process.env.VUE_APP_AUTH')
    return axios.post(`${process.env.VUE_APP_AUTH}/v2/token`, params,
      { headers: { 'Authorization': auth } })
  }
  uploadImg (params) {
    const headers = { 'X-API-KEY': process.env.VUE_APP_ALI_X_API_KEY }
    // const headers = { 'X-API-KEY': '746d2291-d597-482e-a732-b6e7c67be8a2' }
    return axios.post(`${process.env.VUE_APP_ALI_UPLOAD_URL}uploads/base64`,
     params, { headers: headers })
  }
  checkPhone (params) {
    return axios.post(`${process.env.VUE_APP_AUTH}/v2/check-phone`, params,
      { headers: { 'Authorization': auth } })
  }
  changeMobileNum (params) {
    return axios.post(`/eddid/change-mobile-num`, params)
  }
  // 上传图片
  uploadOss (params) {
    return axios.post(`/path/oss/business`, params)
  }
}

export default new Common()
